import { useFormContext } from "react-hook-form";

export const FormRow = ({
  label,
  name,
  children,
}: {
  label: React.ReactNode;
  name: string;
  children: React.ReactNode;
}) => {
  const { formState } = useFormContext();

  // Helper function to get nested error
  const getNestedError = (errors: any, path: string) => {
    const keys = path.split(".");
    let error = errors;

    for (const key of keys) {
      if (error && error[key] !== undefined) {
        error = error[key];
      } else {
        return null;
      }
    }

    return error;
  };

  const error = getNestedError(formState.errors, name);

  return (
    <div className="flex align-items-center gap-3 mb-3">
      <label className="w-3 text-left font-medium">{label}</label>

      <div className="w-9">
        {children}

        {error && error.message && (
          <small className="p-error block mt-1">
            {error.message as string}
          </small>
        )}
      </div>
    </div>
  );
};
